// extracted by mini-css-extract-plugin
export default {"pipelineDetailsRow":"review_pipelineDetailsRow__GiUjW","rowSubTitle":"review_rowSubTitle__4Rllj","rowValues":"review_rowValues__bFHhB","actionBtns":"review_actionBtns__gWHwy"};